import type { Option } from '@webapp2/shared/components/primevue/select'
import type { TechniqueCategory } from '@webapp2/shared/model'

export const techniqueCategories: TechniqueCategory[] = [
  {
    id: '2fd7d003-50a2-46cd-ba52-1c96ec1b305f',
    title: 'Essentials 101',
    type: 'TechniqueCategory'
  },
  {
    id: 'e4bead08-e78c-41ea-951c-7b196860eb0f',
    title: 'Essentials 102',
    type: 'TechniqueCategory'
  },
  {
    id: '69ea6783-8e42-4d48-959f-4c7949663340',
    title: 'Maternal Care',
    type: 'TechniqueCategory'
  }
]

export const techniqueCategoryTitlesById: { [id: string]: string } = techniqueCategories.reduce<{
  [id: string]: string
}>((acc, category) => {
  acc[category.id] = category.title
  return acc
}, {})

export const techniqueCategoryOptions: Option[] = techniqueCategories.map(category => ({
  label: category.title,
  value: category.id
}))
